<template>
  <div>
    <div
      class="flex flex-col m-0 sm:m-0 md:m-0 lg:mx-2 xl:mx-2 lg:mt-2 xl:mt-2 bg-gray-100 p-3"
    >
      <div>
        <p class="font-raleway font-bold text-2xl text-mi-blue-500 uppercase">
          Rollen
        </p>
      </div>

      <PermissionsCard />

      <div
        class="my-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 grid-flow-row gap-4"
      >
        <AddRoleCard />
      </div>
    </div>
  </div>
</template>

<script>
import PermissionsCard from "./PermissionsCard";
import AddRoleCard from "./AddRoleCard";

export default {
  name: "Roles",
  components: {
    PermissionsCard,
    AddRoleCard,
  },
};
</script>
